<template>

  <section class="dp-layout">
    <!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left">
      <DepartmentPane
        directory-scope="teaching"
        pane-title="家校通讯录"
        :show-unassigned-node="isBlogAdmin"
        unassigned-node-label="平台账号（未分配部门）"
        :show-all-schools-node="showAllSchoolsNode"
        all-schools-node-label="全部学校账号"
        @tree-node-click="treeNodeClick">
      </DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="uRealName" label="昵称" width="">
        </el-table-column>
        <el-table-column prop="uLoginName" label="登录名" width="">
        </el-table-column>
        <el-table-column label="手机号" width="130">
          <template slot-scope="scope">
            <span>{{ maskMobilePhone(scope.row.MobilePhone) }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="isBlogAdmin" prop="SchoolName" label="所属学校" min-width="220" class-name="is-wrap-cell">
          <template slot-scope="scope">
            <div v-if="splitJoinedNames(scope.row.SchoolName).length" class="name-cell">
              <el-tag
                v-for="(name, idx) in previewJoinedNames(scope.row.SchoolName)"
                :key="'school-' + idx + '-' + name"
                size="mini"
                type="info"
                effect="plain"
                :title="name"
                class="name-cell__tag">{{ name }}</el-tag>
              <el-button
                v-if="splitJoinedNames(scope.row.SchoolName).length > namePreviewCount"
                type="text"
                size="mini"
                class="name-more-btn"
                @click.stop="openNameListDialog(scope.row, 'SchoolName', '所属学校')">+{{ splitJoinedNames(scope.row.SchoolName).length - namePreviewCount }} 所</el-button>
            </div>
            <el-tag v-else size="mini" type="info" effect="plain">未分配学校</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="RoleNames" label="角色" min-width="130" class-name="is-wrap-cell">
          <template slot-scope="scope">
            <div v-if="scope.row.RoleNames && scope.row.RoleNames.length" class="name-cell">
              <el-tag
                v-for="(item, idx) in scope.row.RoleNames"
                :key="'role-' + idx + '-' + item"
                size="mini"
                :title="item"
                disable-transitions
                class="name-cell__tag">{{ item }}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="DepartmentName" label="所属部门" min-width="220" class-name="is-wrap-cell">
          <template slot-scope="scope">
            <div v-if="splitJoinedNames(scope.row.DepartmentName).length" class="name-cell">
              <el-tag
                v-for="(name, idx) in previewJoinedNames(scope.row.DepartmentName)"
                :key="'dept-' + idx + '-' + name"
                size="mini"
                type="info"
                effect="plain"
                :title="name"
                class="name-cell__tag">{{ name }}</el-tag>
              <el-button
                v-if="splitJoinedNames(scope.row.DepartmentName).length > namePreviewCount"
                type="text"
                size="mini"
                class="name-more-btn"
                @click.stop="openNameListDialog(scope.row, 'DepartmentName', '所属部门')">+{{ splitJoinedNames(scope.row.DepartmentName).length - namePreviewCount }} 个</el-button>
            </div>
            <el-tag v-else size="mini" type="info" effect="plain">未分配部门</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="uStatus" label="状态" width="">
          <template slot-scope="scope">
            <el-tag :type="scope.row.uStatus == 0 ? 'success' : 'danger'" disable-transitions>{{ scope.row.uStatus == 0
              ?
              "正常" : "禁用" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="!shouldSkipAssignDept(scope.row)"
              size="mini"
              type="text"
              icon="el-icon-office-building"
              class="op-btn-assign"
              @click.stop="openAssignDeptDialog(scope.row)">分配部门</el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-view"
              class="op-btn-pwd"
              @click.stop="openResetPasswordDialog(scope.row)">查看密码</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
          style="float: right">
        </el-pagination>
      </el-col>

      <!--编辑界面-->
      <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
        <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
          <el-form-item label="昵称" prop="uRealName">
            <el-input v-model="editForm.uRealName" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="登录名" prop="uLoginName">
            <el-input v-model="editForm.uLoginName" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="MobilePhone">
            <el-input
              v-model="editForm.MobilePhone"
              maxlength="11"
              clearable
              placeholder="可选；清空后提交即解绑"
              @input="onMobilePhoneInput('editForm')"></el-input>
            <div class="mobile-phone-tip">管理员可直接绑定、换绑或清空解绑，无需短信验证码。</div>
          </el-form-item>
          <!--<el-form-item label="密码" prop="uLoginPWD">-->
          <!--<el-input v-model="editForm.uLoginPWD" show-password  auto-complete="off"></el-input>-->
          <!--</el-form-item>-->

          <el-form-item label="角色" prop="RIDs">
            <el-select multiple :multiple-limit="1" v-model="editForm.RIDs" placeholder="请选择角色">
              <el-option :key="0" :label="'未选择角色'" :value="0"></el-option>
              <el-option v-for="item in roles" :key="item.Id" :label="item.Description" :value="item.Id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="性别">
            <el-radio-group v-model="editForm.sex" v-removeAriaHidden>
              <el-radio class="radio" :label="1">男</el-radio>
              <el-radio class="radio" :label="0">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="年龄">
            <el-input-number v-model="editForm.age" :min="0" :max="200"></el-input-number>
          </el-form-item>
          <el-form-item label="生日">
            <el-date-picker type="date" placeholder="选择日期" v-model="editForm.birth"></el-date-picker>
          </el-form-item>
          <el-form-item label="地址">
            <el-input type="textarea" v-model="editForm.addr"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
          <el-form-item label="昵称" prop="uRealName">
            <el-input v-model="addForm.uRealName" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="登录名" prop="uLoginName">
            <el-input v-model="addForm.uLoginName" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="MobilePhone">
            <el-input
              v-model="addForm.MobilePhone"
              maxlength="11"
              clearable
              placeholder="可选，11 位手机号"
              @input="onMobilePhoneInput('addForm')"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="uLoginPWD">
            <password-input v-model="addForm.uLoginPWD" placeholder="请输入密码"></password-input>
          </el-form-item>
          <el-alert
            title="部门请在用户创建后，通过列表「分配部门」单独设置"
            type="info"
            :closable="false"
            show-icon
            class="add-dept-hint">
          </el-alert>
          <el-form-item label="性别">
            <el-radio-group v-model="addForm.sex" v-removeAriaHidden>
              <el-radio class="radio" :label="1">男</el-radio>
              <el-radio class="radio" :label="0">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="年龄">
            <el-input-number v-model="addForm.age" :min="0" :max="200"></el-input-number>
          </el-form-item>
          <el-form-item label="生日">
            <el-date-picker type="date" placeholder="选择日期" v-model="addForm.birth"></el-date-picker>
          </el-form-item>
          <el-form-item label="地址">
            <el-input type="textarea" v-model="addForm.addr"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <!-- 所属学校过多时弹窗查看。创建于 2026-08-27 -->
      <el-dialog
        :title="schoolListDialogTitle"
        :visible.sync="schoolListDialogVisible"
        width="560px"
        custom-class="school-list-dialog"
        append-to-body>
        <div class="school-list-pop">
          <el-tag
            v-for="name in schoolListDialogNames"
            :key="name"
            size="small"
            type="info"
            effect="plain"
            class="school-list-pop__tag">{{ name }}</el-tag>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="schoolListDialogVisible = false">关 闭</el-button>
        </div>
      </el-dialog>

      <!-- 分配部门弹窗：学校级 / 子部门分开展示。最后更新：2026-08-26 -->
      <el-dialog
        title="分配部门"
        :visible.sync="assignDeptVisible"
        width="880px"
        custom-class="assign-dept-dialog dialog-theme"
        :close-on-click-modal="false"
        append-to-body
        @closed="onAssignDeptClosed">
        <div class="ad-shell">
          <div class="ad-header" v-if="assignDeptUser">
            <div class="ad-header-left">
              <div class="ad-avatar"><i class="el-icon-user-solid"></i></div>
              <div class="ad-user">
                <div class="ad-name">
                  <span>{{ assignDeptUser.uRealName || '-' }}</span>
                  <span v-if="assignDeptScopeSchoolId > 0" class="ad-scope-badge">
                    <i class="el-icon-office-building"></i> {{ assignDeptScopeSchoolName || '当前学校' }}
                  </span>
                  <span v-else class="ad-scope-badge ad-scope-badge--all">
                    <i class="el-icon-connection"></i> 全部学校
                  </span>
                </div>
                <div class="ad-sub">
                  {{ assignDeptUser.uLoginName || '-' }} · 学校级管整校，子部门管局部
                  <el-button
                    v-if="isBlogAdmin && assignDeptScopeSchoolId > 0"
                    type="text"
                    size="mini"
                    class="ad-scope-switch-btn"
                    icon="el-icon-refresh"
                    @click="switchAssignScopeToAll">
                    切换为全部学校
                  </el-button>
                </div>
              </div>
            </div>
            <div class="ad-stats">
              <span class="ad-stat-pill"><b>{{ assignSchoolIds.length }}</b> 学校</span>
              <span class="ad-stat-pill"><b>{{ assignSubDeptNodes.length }}</b> 子部门</span>
            </div>
          </div>

          <div class="ad-content">
          <div v-if="assignDeptOverlapInfo.hasOverlap" class="ad-overlap-tip">
            <i class="el-icon-warning-outline"></i>
            <span>
              学校级权限已覆盖
              <b>{{ assignDeptOverlapInfo.schoolText }}</b>
              整校，同校 {{ assignDeptOverlapInfo.overlapCount }} 项子部门不会额外生效。若只需管局部，请去掉学校级、仅保留子部门。
            </span>
          </div>

          <div class="ad-main">
            <div class="ad-picker">
              <div class="ad-seg">
                <button
                  type="button"
                  class="ad-seg-item"
                  :class="{ active: assignDeptTab === 'school' }"
                  @click="assignDeptTab = 'school'">
                  <i class="el-icon-office-building"></i> 学校级
                </button>
                <button
                  type="button"
                  class="ad-seg-item"
                  :class="{ active: assignDeptTab === 'sub' }"
                  @click="assignDeptTab = 'sub'">
                  <i class="el-icon-share"></i> 子部门
                </button>
              </div>

              <div class="ad-pane">
                <el-input
                  v-show="assignDeptTab === 'school'"
                  v-model="assignSchoolFilter"
                  size="small"
                  clearable
                  prefix-icon="el-icon-search"
                  placeholder="搜索学校">
                </el-input>
                <el-input
                  v-show="assignDeptTab === 'sub'"
                  v-model="assignSubDeptFilter"
                  size="small"
                  clearable
                  prefix-icon="el-icon-search"
                  placeholder="搜索部门（支持跨校）">
                </el-input>
                <p v-if="assignDeptTab === 'sub'" class="ad-hint-line">
                  <i class="el-icon-info"></i>
                  <span>勾选上级将自动勾选全部下级；可直接勾选学校节点批量选择该校全部子部门</span>
                </p>
                <div
                  class="ad-scroll"
                  :class="{ 'ad-scroll--tree': assignDeptTab === 'sub' }"
                  v-loading="assignDeptTreeLoading">
                  <div v-if="assignDeptTab === 'school'" class="ad-scroll-pane">
                    <el-checkbox-group
                      v-if="filteredAssignSchoolList.length"
                      :value="assignSchoolIds"
                      class="ad-school-list"
                      @input="onAssignSchoolChange">
                      <div
                        v-for="school in filteredAssignSchoolList"
                        :key="'school-' + school.value"
                        :data-assign-school-id="school.value"
                        class="ad-school-row"
                        :class="{ active: isAssignSchoolSelected(school.value) }"
                        @click="toggleAssignSchool(school.value)">
                        <el-checkbox :label="school.value" @click.native.prevent.stop="toggleAssignSchool(school.value)">
                          {{ school.label }}
                        </el-checkbox>
                      </div>
                    </el-checkbox-group>
                    <div v-else-if="!assignDeptTreeLoading" class="ad-empty">
                      {{ assignSchoolList.length ? '无匹配学校' : '暂无学校数据' }}
                    </div>
                  </div>
                  <div v-else class="ad-scroll-pane ad-scroll-pane--tree">
                    <!-- 必须在 Tab 可见时再挂载树；分配用完整组织树（含年级/班级）。最后更新：2026-09-03 -->
                    <el-tree
                      v-if="assignSubDeptTree.length"
                      ref="assignSubDeptTree"
                      :data="assignSubDeptTree"
                      :props="{ label: 'label', children: 'children', disabled: 'disabled' }"
                      node-key="value"
                      show-checkbox
                      :default-expanded-keys="assignSubDeptExpandKeys"
                      :expand-on-click-node="false"
                      :filter-node-method="filterAssignDeptNode"
                      class="ad-dept-tree"
                      @check="onAssignSubDeptCheck">
                    </el-tree>
                    <div v-else-if="!assignDeptTreeLoading" class="ad-empty">
                      暂无学校/部门数据
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="ad-summary">
              <div class="ad-summary-top">
                <span>已选权限</span>
                <span class="ad-summary-count">{{ assignSchoolIds.length + assignSubDeptIds.length }}</span>
                <button
                  type="button"
                  class="ad-link"
                  :disabled="!assignSchoolIds.length && !assignSubDeptIds.length"
                  @click="clearAssignDeptSelection">全部清空</button>
              </div>

              <div class="ad-summary-body">
              <div class="ad-summary-group">
                <div class="ad-summary-label">
                  <span>学校级</span>
                  <em>{{ assignSchoolNodes.length }}</em>
                </div>
                <div class="ad-pick-list" v-if="assignSchoolNodes.length">
                  <div
                    v-for="node in assignSchoolNodes"
                    :key="'s-' + node.value"
                    class="ad-pick-item school is-locatable"
                    title="点击定位到左侧"
                    @click="locateAssignSchool(node.value)">
                    <i class="el-icon-office-building"></i>
                    <span class="ad-pick-text" :title="node.label">{{ node.label }}</span>
                    <button type="button" class="ad-pick-remove" title="移除" @click.stop="removeAssignSchool(node.value)">
                      <i class="el-icon-close"></i>
                    </button>
                  </div>
                </div>
                <div v-else class="ad-empty sm">未选择学校级权限</div>
              </div>

              <div class="ad-summary-group">
                <div class="ad-summary-label">
                  <span>子部门</span>
                  <em>{{ assignSubDeptNodes.length }}</em>
                  <button
                    v-if="assignSubDeptNodes.length"
                    type="button"
                    class="ad-link"
                    @click="clearAssignSubDepts">清空</button>
                </div>
                <div class="ad-pick-list" v-if="assignSubDeptNodes.length">
                  <div
                    v-for="node in assignSubDeptNodes"
                    :key="'d-' + node.value"
                    class="ad-pick-item is-locatable"
                    title="点击定位到左侧"
                    @click="locateAssignSubDept(node.value)">
                    <i class="el-icon-folder-opened"></i>
                    <div class="ad-pick-main">
                      <span class="ad-pick-text" :title="node.fullLabel || node.label">{{ node.label }}</span>
                      <span v-if="node.childCount" class="ad-pick-extra">含 {{ node.childCount }} 个下级</span>
                      <span v-else-if="node.schoolName" class="ad-pick-extra">{{ node.schoolName }}</span>
                    </div>
                    <button type="button" class="ad-pick-remove" title="移除" @click.stop="removeAssignSubDept(node.value)">
                      <i class="el-icon-close"></i>
                    </button>
                  </div>
                </div>
                <div v-else class="ad-empty sm">未选择子部门权限</div>
              </div>
              </div>
            </div>
          </div>
          </div>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="assignDeptVisible = false">取消</el-button>
          <el-button type="primary" :loading="assignDeptLoading"
            :disabled="assignDeptTreeLoading" @click="submitAssignDept">保存分配</el-button>
        </div>
      </el-dialog>

      <!-- 用户密码安全管理界面 -->
      <el-dialog title="用户密码安全管理" :visible.sync="resetPwdVisible" width="450px" :close-on-click-modal="false" append-to-body>
        <div class="pwd-dialog-content">
          <!-- 步骤一：安全验证 -->
          <div v-if="!isAuthorized" class="auth-panel">
            <div class="auth-icon">
              <i class="el-icon-lock"></i>
            </div>
            <div class="auth-tips">您正在尝试查看或重置 [{{ resetPwdForm.uRealName }}] 的登录密码，请输入专属操作授权密码以确认身份。</div>
            <el-form :model="resetPwdForm" :rules="resetPwdRules" ref="authForm" label-width="0">
              <el-form-item prop="authCode">
                <password-input v-model="resetPwdForm.authCode" placeholder="请输入操作授权密码" @keyup.enter.native="handleAuthValidate"></password-input>
              </el-form-item>
            </el-form>
            <div style="margin-top: 20px;">
              <el-button @click="resetPwdVisible = false">取消</el-button>
              <el-button type="primary" @click="handleAuthValidate" :loading="authLoading">验证授权</el-button>
            </div>
          </div>

          <!-- 步骤二：密码详情与重置 -->
          <div v-else>
            <el-form :model="resetPwdForm" :rules="resetPwdRules" ref="resetPwdForm" label-width="100px">
              <el-form-item label="登录名">
                <el-input :value="resetPwdForm.uLoginName" disabled></el-input>
              </el-form-item>
              <el-form-item label="昵称">
                <el-input :value="resetPwdForm.uRealName" disabled></el-input>
              </el-form-item>
              
              <!-- 密码明文转译卡片 - 解析成功 -->
              <div v-if="decodedPlainPassword" class="pwd-analysis-card" style="border-color: #67c23a; background: linear-gradient(135deg, rgba(103, 194, 58, 0.05) 0%, rgba(225, 243, 216, 0.05) 100%);">
                <div class="pwd-analysis-title" style="color: #67c23a;">
                  <i class="el-icon-circle-check"></i>
                  <span>数据库密文转译成功！</span>
                </div>
                <div class="pwd-hash-value" style="color: #67c23a; font-weight: bold; font-size: 16px; border-color: #c2e7b0; background-color: #f0f9eb; text-align: center;">
                  {{ decodedPlainPassword }}
                </div>
                <div class="pwd-analysis-desc" style="color: #67c23a;">
                  解析成功！系统已自动匹配并还原该用户的登录明文密码。若您不需要修改，可直接关闭此窗口；如需修改，请在下方设定新密码。
                </div>
              </div>

              <!-- 密码明文转译卡片 - 解析失败 -->
              <div v-else class="pwd-analysis-card">
                <div class="pwd-analysis-title">
                  <i class="el-icon-warning-outline"></i>
                  <span>数据库密文转译分析</span>
                </div>
                <div class="pwd-hash-value">
                  {{ rawLoginPWD || '密码字段为空或未设置' }}
                </div>
                <div class="pwd-analysis-desc">
                  当前数据库中该用户的密码采用单向不可逆 MD5 散列算法进行哈希加密存储。在数学上该密文无法直接反向转译还原为初始明文密码。我们已为您解锁快捷重置密码功能，您可以在下方直接设定新密码并加密存盘。
                </div>
              </div>

              <el-form-item label="设定新密码" prop="newPassword">
                <password-input v-model="resetPwdForm.newPassword" placeholder="请输入要重置的新密码"></password-input>
              </el-form-item>
            </el-form>
            <div style="text-align: right; margin-top: 20px;">
              <el-button @click="resetPwdVisible = false">关闭</el-button>
              <el-button type="primary" @click="submitResetPassword" :loading="resetPwdLoading">确认修改并加密存盘</el-button>
            </div>
          </div>
        </div>
      </el-dialog>
    </section>

  </section>

</template>

<script>
import util from "../../../util/date";
import { getUserListPage, getRoleListPage, removeUser, batchRemoveUser, editUser, addUser, resetUserPassword, decodeUserPassword } from '../../api/modules/system';
import { getDepartmentTree, getDepartmentType } from '../../api/modules/department';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import PasswordInput from '../../components/PasswordInput'
import superAdminMixin from '../../mixins/superAdminMixin'
import { isSuperAdmin } from '../../utils/authUser'
import { normalizeDeptId, deptIdsEqual, resolveActiveSchoolId } from '../../utils/deptCascaderProps'

export default {
  components: { Toolbar, DepartmentPane, PasswordInput },
  mixins: [superAdminMixin],
  data() {
    return {
      filters: {
        name: "",
      },
      BaseApiUrl: BaseApiUrl, //网络前缀
      users: [],
      roles: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列

      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        uLoginName: [
          { required: true, message: "请输入登录名", trigger: "blur" },
        ],
        uRealName: [{ required: true, message: "请输入昵称", trigger: "blur" }],
        birth: [{ required: true, message: "请填写生日", trigger: "blur" }],
        MobilePhone: [
          {
            validator(rule, value, callback) {
              const phone = String(value || "").trim();
              if (!phone) {
                callback();
                return;
              }
              if (!/^1[3-9]\d{9}$/.test(phone)) {
                callback(new Error("请输入合规的 11 位手机号"));
                return;
              }
              callback();
            },
            trigger: "blur",
          },
        ],
      },
      //编辑界面数据
      editForm: {
        id: 0,
        uID: 0,
        RIDs: 0,
        uLoginName: "",
        uRealName: "",
        MobilePhone: "",
        name: "",
        sex: -1,
        age: 0,
        birth: "",
        addr: "",
        Dids: [],
        DepartmentId: 0,
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        uLoginName: [
          { required: true, message: "请输入登录名", trigger: "blur" },
        ],
        uRealName: [{ required: true, message: "请输入昵称", trigger: "blur" }],
        uLoginPWD: [{ required: true, message: "请输入密码", trigger: "blur" }],
        birth: [{ required: true, message: "请填写生日", trigger: "blur" }],
        MobilePhone: [
          {
            validator(rule, value, callback) {
              const phone = String(value || "").trim();
              if (!phone) {
                callback();
                return;
              }
              if (!/^1[3-9]\d{9}$/.test(phone)) {
                callback(new Error("请输入合规的 11 位手机号"));
                return;
              }
              callback();
            },
            trigger: "blur",
          },
        ],
      },
      //新增界面数据
      addForm: {
        name: "",
        uLoginName: "",
        uRealName: "",
        MobilePhone: "",
        uLoginPWD: "",
        sex: -1,
        age: 0,
        birth: "",
        Dids: [],
        DepartmentId: 0,
        addr: "",
      },
      DepartmentId: 0,
      // 左侧树当前学校范围：>0 时分配部门只展示该校；0 表示全平台。创建于 2026-09-03
      listScopeSchoolId: 0,

      // 分配部门弹窗（学校级 / 子部门分开）
      assignDeptVisible: false,
      assignDeptLoading: false,
      assignDeptTreeLoading: false,
      assignDeptUser: null,
      assignDeptTab: "school",
      assignDeptNodeMap: {},
      // 家校树顶层节点（构建子部门树用，不单依赖学校级勾选列表）
      assignDeptTopNodes: [],
      assignSchoolList: [],
      assignSchoolFilter: "",
      assignSchoolIds: [],
      assignSchoolNodes: [],
      assignSubDeptTree: [],
      assignSubDeptExpandKeys: [],
      assignSubDeptFilter: "",
      assignSubDeptIds: [],
      assignSubDeptNodes: [],
      // 当前学校范围外保留的原绑定，保存时合并。创建于 2026-09-03
      assignPreservedOutOfScopeIds: [],
      // 回显时避免级联勾选触发重复同步
      assignSubDeptSyncing: false,
      // 分配部门树请求序号，避免首次/重复打开串响应。创建于 2026-09-03
      assignDeptTreeRequestId: 0,
      // 分配部门当前实际限定的学校 Id（0 表示全平台）。创建于 2026-09-07
      assignDeptScopeSchoolId: 0,
      // 分配部门当前限定学校名称。创建于 2026-09-07
      assignDeptScopeSchoolName: "",

      // 重置密码弹窗控制与表单
      resetPwdVisible: false,
      resetPwdLoading: false,
      isAuthorized: false, // 是否已经通过授权校验
      authLoading: false, // 授权验证时的加载状态
      rawLoginPWD: "", // 选中的用户MD5密码密文
      decodedPlainPassword: "", // 解析出的明文密码
      resetPwdForm: {
        userId: 0,
        uLoginName: "",
        uRealName: "",
        authCode: "",
        newPassword: ""
      },
      resetPwdRules: {
        authCode: [{ required: true, message: "请输入授权密码", trigger: "blur" }],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, max: 20, message: "密码长度须在 6 到 20 个字符之间", trigger: "blur" }
        ]
      },
      schoolListDialogVisible: false,
      schoolListDialogTitle: "",
      schoolListDialogNames: [],
      namePreviewCount: 2,
    };
  },
  created() {
    // 超管默认查全部学校账号（顶栏通常已有默认学校，节点始终展示）。最后修改：2026-08-27
    if (this.showAllSchoolsNode) {
      this.DepartmentId = -2;
    }
  },
  computed: {
    /**
     * 超管展示「全部学校账号」，且左侧树/分配部门不跟随顶栏学校。最后修改：2026-09-03
     */
    showAllSchoolsNode() {
      return this.isBlogAdmin;
    },
    /**
     * 学校列表本地搜索过滤。创建于 2026-08-26
     */
    filteredAssignSchoolList() {
      const keyword = (this.assignSchoolFilter || "").trim().toLowerCase();
      if (!keyword) return this.assignSchoolList;
      return this.assignSchoolList.filter((school) =>
        String(school.label || "").toLowerCase().indexOf(keyword) > -1
      );
    },

    /**
     * 学校级与子部门重叠提示（同校子部门被学校级覆盖）。创建于 2026-08-26
     */
    assignDeptOverlapInfo() {
      const schoolIdSet = {};
      (this.assignSchoolIds || []).forEach((id) => {
        const key = normalizeDeptId(id);
        if (key) schoolIdSet[key] = true;
      });
      if (!Object.keys(schoolIdSet).length || !this.assignSubDeptNodes.length) {
        return { hasOverlap: false, schoolText: "", overlapCount: 0 };
      }

      const overlapSchoolNames = {};
      let overlapCount = 0;
      this.assignSubDeptNodes.forEach((node) => {
        const deptNode = this.assignDeptNodeMap[normalizeDeptId(node.value)] || this.assignDeptNodeMap[node.value];
        const schoolId = this.findAssignSchoolIdByNode(deptNode);
        const schoolKey = normalizeDeptId(schoolId);
        if (schoolKey && schoolIdSet[schoolKey]) {
          overlapCount += 1;
          const school = this.assignSchoolList.find((s) => deptIdsEqual(s.value, schoolId));
          overlapSchoolNames[schoolKey] = school ? school.label : String(schoolId);
        }
      });

      const schoolNames = Object.keys(overlapSchoolNames).map((id) => overlapSchoolNames[id]);
      return {
        hasOverlap: overlapCount > 0,
        schoolText: schoolNames.join("、"),
        overlapCount,
      };
    },
  },
  methods: {

    treeNodeClick(data, node, component) {
      // 虚拟节点：-1 平台未分配账号；-2 全部学校账号。仅超管可见。最后修改：2026-09-03
      const raw = data && data.value;
      const orgType = String((data && (data.DeptOrgType || data.deptOrgType)) || "").toLowerCase();
      if (Number(raw) === -2 || orgType === "allschools") {
        if (!this.isBlogAdmin) {
          this.$message({ message: "无权限查看全部学校账号", type: "error" });
          return;
        }
        this.DepartmentId = -2;
        this.listScopeSchoolId = 0;
      } else if (Number(raw) === -1 || orgType === "platform") {
        if (!this.isBlogAdmin) {
          this.$message({ message: "无权限查看平台账号", type: "error" });
          return;
        }
        this.DepartmentId = 0;
        this.listScopeSchoolId = 0;
      } else {
        this.DepartmentId = raw;
        const syncSchoolId = this.resolveListScopeSchoolId(data, node);
        this.listScopeSchoolId = syncSchoolId;
        // 左侧点到校区/年级/班级时，树父链可能拿不到学校，再按部门反查
        if (!syncSchoolId && normalizeDeptId(raw)) {
          const clickedId = raw;
          this.fetchSchoolIdByDeptId(clickedId).then((schoolId) => {
            if (String(this.DepartmentId) !== String(clickedId)) return;
            this.listScopeSchoolId = schoolId || 0;
          });
        }
      }
      this.handleQuery()
    },

    /**
     * 根据任意部门 Id 反查所属学校 Id。创建于 2026-09-03
     */
    fetchSchoolIdByDeptId(deptId) {
      const id = deptId == null ? "" : String(deptId).trim();
      if (!normalizeDeptId(id)) return Promise.resolve('');
      return getDepartmentType({ id }).then((res) => {
        const dept = res.data && res.data.response;
        if (!dept) return '';
        return normalizeDeptId(dept.Id != null ? dept.Id : dept.id);
      }).catch(() => '');
    },

    /**
     * 分配部门使用的学校范围：左侧树明确选中某所学校时限定该校；全部学校账号/平台账号/超管全局视图时为 0（全平台）。
     * 绝不能拿用户已有的部门反查并锁死单校，否则会导致多校账号在全部学校账号下无法跨校添加其他学校。最后修改：2026-09-07
     */
    resolveAssignScopeSchoolId(row) {
      // 1. 如果左侧处于「全部学校账号」（DepartmentId === -2）或「平台账号」（DepartmentId === 0），必须展示全平台全部学校
      if (Number(this.DepartmentId) === -2 || this.DepartmentId === 0 || this.DepartmentId === '0') {
        return Promise.resolve(0);
      }

      // 2. 如果从左侧树解析到了明确的学校（点击了学校、校区、年级、班级等节点）
      const fromList = normalizeDeptId(this.listScopeSchoolId);
      if (fromList) return Promise.resolve(fromList);

      // 3. 如果左侧选了具体子部门节点，反查其归属学校
      const leftDeptId = normalizeDeptId(this.DepartmentId);
      if (leftDeptId) {
        return this.fetchSchoolIdByDeptId(leftDeptId);
      }

      // 4. 其他情况（包括全局视图、未选单校节点）默认均为全平台 0
      return Promise.resolve(0);
    },

    /**
     * 超管在分配部门弹窗中一键切换为全平台全部学校范围。创建于 2026-09-07
     */
    switchAssignScopeToAll() {
      if (!this.isBlogAdmin) return;
      // 保留当前已选的全部学校和子部门
      const currentSelected = (this.assignSchoolIds || [])
        .concat(this.assignSubDeptIds || [])
        .concat(this.assignPreservedOutOfScopeIds || []);
      this.loadAssignDeptTree(currentSelected, 0);
    },

    /**
     * 从左侧树点击解析当前学校 Id（点学校或其下级都算该校）。创建于 2026-09-03
     */
    resolveListScopeSchoolId(data, treeNode) {
      const tryNode = (item) => {
        if (!item) return 0;
        const id = Number(item.value);
        if (!Number.isFinite(id) || id <= 0) return 0;
        const orgType = String(item.DeptOrgType || item.deptOrgType || "").toLowerCase();
        if (orgType === "platform" || orgType === "allschools") return 0;
        if (orgType === "school" || orgType === "affiliateschool") return id;
        if (!orgType && Number(item.Pid) === 0) return id;
        return 0;
      };
      const selfId = tryNode(data);
      if (selfId) return selfId;
      let current = treeNode;
      const guard = {};
      while (current && current.data) {
        const id = Number(current.data.value);
        if (id && guard[id]) break;
        if (id) guard[id] = true;
        const found = tryNode(current.data);
        if (found) return found;
        current = current.parent;
      }
      return 0;
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    /**
     * 将顿号/点分隔的名称拆成列表。创建于 2026-08-27
     */
    splitJoinedNames(value) {
      const text = this.displayJoinedName(value);
      return text ? text.split("、").filter(Boolean) : [];
    },
    /**
     * 列表默认只展示前几项名称。创建于 2026-08-27
     */
    previewJoinedNames(value) {
      return this.splitJoinedNames(value).slice(0, this.namePreviewCount);
    },
    /**
     * 弹窗查看全部所属学校或部门。创建于 2026-08-27
     */
    openNameListDialog(row, field, label) {
      const names = this.splitJoinedNames(row && row[field]);
      const who = (row && (row.uRealName || row.uLoginName)) || "该用户";
      this.schoolListDialogNames = names;
      this.schoolListDialogTitle = `${who} · ${label}（${names.length}）`;
      this.schoolListDialogVisible = true;
    },
    /**
     * 去掉名称末尾多余的间隔点（如「未分配部门 ·」）。创建于 2026-08-27
     */
    displayJoinedName(value) {
      const raw = String(value == null ? "" : value).trim();
      if (!raw) return "";
      const parts = raw.split(/\s*[·、，,]\s*/).map((s) => s.trim()).filter(Boolean);
      return parts.join("、");
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    //获取用户列表
    handleQuery() {
      let para = {
        page: this.page,
        // 显式传字符串，确保 departmentId=0 不会被忽略
        departmentId: String(this.DepartmentId == null ? "" : this.DepartmentId),
        ...this.filters,
      };
      this.listLoading = true;

      //NProgress.start();
      getUserListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    /**
     * 系统内置账号 admin / blogadmin，不允许增删改和分配部门。创建于 2026-08-27
     */
    isReservedSystemAccount(row) {
      return isSuperAdmin(row);
    },
    /**
     * 角色为 SuperAdmin 的账号无需分配部门。创建于 2026-08-27
     */
    hasSuperAdminRole(row) {
      const names = (row && row.RoleNames) || [];
      return names.some((n) => {
        const s = String(n || "").trim().toLowerCase();
        return s === "superadmin" || s === "超级管理员";
      });
    },
    /**
     * 内置账号与 SuperAdmin 角色都不走分配部门。创建于 2026-08-27
     */
    shouldSkipAssignDept(row) {
      return this.isReservedSystemAccount(row) || this.hasSuperAdminRole(row);
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      if (this.isReservedSystemAccount(row)) {
        this.$message({
          message: "系统内置账号 admin / blogadmin 不允许删除",
          type: "warning",
        });
        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.uID };
          removeUser(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      if (this.isReservedSystemAccount(row)) {
        this.$message({
          message: "系统内置账号 admin / blogadmin 不允许编辑",
          type: "warning",
        });
        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      if (!this.editForm.Dids) {
        this.$set(this.editForm, 'Dids', []);
      }
      if (this.editForm.MobilePhone == null) {
        this.$set(this.editForm, 'MobilePhone', '');
      }

      getRoleListPage().then((res) => {
        this.roles = res.data.response.data;
      });
    },
    //显示新增界面
    handleAdd() {
      if (Number(this.DepartmentId) === -2) {
        this.$message({
          message: "请先选择具体学校或「平台账号」后再新增",
          type: "warning",
        });
        return;
      }
      this.addFormVisible = true;
      this.addForm = {
        uLoginName: "",
        uRealName: "",
        MobilePhone: "",
        uLoginPWD: "",
        name: "",
        sex: -1,
        age: 0,
        Dids: [],
        DepartmentId: 0,
        birth: "",
        addr: "",
      };
    },
    /**
     * 手机号输入仅保留数字。创建于 2026-10-29
     */
    onMobilePhoneInput(formKey) {
      const form = this[formKey];
      if (!form) return;
      const value = String(form.MobilePhone || '').replace(/\D/g, '').slice(0, 11);
      this.$set(form, 'MobilePhone', value);
    },
    /**
     * 可选手机号格式校验。创建于 2026-10-29
     */
    validateMobilePhoneOptional(rule, value, callback) {
      const phone = String(value || '').trim();
      if (!phone) {
        callback();
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(phone)) {
        callback(new Error('请输入合规的 11 位手机号'));
        return;
      }
      callback();
    },
    /**
     * 列表脱敏展示手机号。创建于 2026-10-29
     */
    maskMobilePhone(phone) {
      const value = String(phone || '').trim();
      if (!value) return '-';
      if (value.length === 11) return value.slice(0, 3) + '****' + value.slice(7);
      return value;
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            let para = Object.assign({}, this.editForm);

            if (this.isReservedSystemAccount(para)) {
              this.$message({
                message: "系统内置账号 admin / blogadmin 不允许编辑",
                type: "warning",
              });
              return;
            }
            if (isSuperAdmin(para.uLoginName) && !this.isReservedSystemAccount(this.currentRow)) {
              this.$message({
                message: "不允许将登录名改为 admin / blogadmin",
                type: "warning",
              });
              return;
            }

            this.editLoading = true;

            para.birth =
              !para.birth || para.birth == ""
                ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");

            // 普通编辑不改部门：去掉 Dids，避免空数组触发后端清空 UserDepartment。部门仅走「分配部门」。最后更新：2026-08-26
            delete para.Dids;
            editUser(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.editLoading = false;
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            let para = Object.assign({}, this.addForm);
            if (isSuperAdmin(para.uLoginName)) {
              this.$message({
                message: "不允许新增 admin / blogadmin 账号",
                type: "warning",
              });
              return;
            }
            this.addLoading = true;
            para.birth =
              !para.birth || para.birth == ""
                ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");

            // 兼容原有单值 DepartmentId，默认取绑定的第一个部门
            para.DepartmentId = para.Dids && para.Dids.length > 0 ? para.Dids[0] : 0;
            addUser(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                const createdId = Number(res.data.response) || 0;
                const createdSnapshot = Object.assign({}, para, {
                  uID: createdId,
                  Id: createdId,
                  RIDs: [],
                  Dids: [],
                  DepartmentId: 0,
                });
                // 分配部门走编辑接口，切勿带上新增表单明文密码。最后更新：2026-08-26
                delete createdSnapshot.uLoginPWD;
                delete createdSnapshot.LoginPWD;
                this.handleQuery();
                if (createdId > 0 && !this.shouldSkipAssignDept(createdSnapshot)) {
                  this.$confirm("用户已创建，是否立即分配部门？", "分配部门", {
                    confirmButtonText: "去分配",
                    cancelButtonText: "稍后",
                    type: "info",
                  })
                    .then(() => {
                      this.openAssignDeptDialog(createdSnapshot);
                    })
                    .catch(() => {});
                }
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },

    /**
     * 打开分配部门弹窗（可从操作列或工具栏 handleAssignDept 触发）。最后更新：2026-08-26
     */
    openAssignDeptDialog(row) {
      if (!row || !row.uID) {
        this.$message({
          message: "请选择要分配部门的用户！",
          type: "error",
        });
        return;
      }
      if (this.shouldSkipAssignDept(row)) {
        this.$message({
          message: this.isReservedSystemAccount(row)
            ? "系统内置账号无需分配部门"
            : "超级管理员可查看全部数据，无需分配部门",
          type: "warning",
        });
        return;
      }
      this.assignDeptUser = Object.assign({}, row);
      this.assignDeptTab = "school";
      this.assignSchoolFilter = "";
      this.assignSubDeptFilter = "";
      this.assignSubDeptTree = [];
      this.assignSubDeptExpandKeys = [];
      this.assignSchoolIds = [];
      this.assignSchoolNodes = [];
      this.assignSubDeptIds = [];
      this.assignSubDeptNodes = [];
      this.assignSchoolList = [];
      this.assignDeptTopNodes = [];
      this.assignDeptNodeMap = {};
      this.assignPreservedOutOfScopeIds = [];
      this.assignDeptVisible = true;
      // 合并 Dids 与主部门，避免列表仅有 DepartmentName 时右侧空白。最后更新：2026-09-03
      const initialDids = Array.isArray(row.Dids) ? row.Dids.slice() : [];
      if (row.DepartmentId) {
        const mainId = normalizeDeptId(row.DepartmentId);
        if (mainId && !initialDids.some((id) => deptIdsEqual(id, mainId))) {
          initialDids.push(row.DepartmentId);
        }
      }
      this.loadAssignDeptTree(initialDids);
    },

    /**
     * 工具栏入口：按当前选中行打开分配部门。创建于 2026-08-26
     */
    handleAssignDept() {
      this.openAssignDeptDialog(this.currentRow);
    },

    /**
     * 判断是否为学校级节点。最后更新：2026-09-03
     */
    isAssignSchoolNode(node) {
      if (!node || node.value == null || node.value === "") return false;
      const id = Number(node.value);
      // 总平台 value 可能是字符串 "0"（truthy），必须排除
      if (!Number.isFinite(id) || id <= 0) return false;
      const orgType = String(node.DeptOrgType || node.deptOrgType || "").toLowerCase();
      if (orgType === "platform") return false;
      if (orgType === "school" || orgType === "affiliateschool") return true;
      // 兜底：挂在总平台下且无明确组织类型，按学校处理
      return !orgType && Number(node.Pid) === 0;
    },

    /**
     * 是否为总平台壳节点。创建于 2026-09-03
     */
    isAssignPlatformNode(node) {
      if (!node) return false;
      const value = Number(node.value);
      const label = String(node.label || node.Name || "");
      const orgType = String(node.DeptOrgType || node.deptOrgType || "").toLowerCase();
      return value === 0 || label === "总平台" || orgType === "platform";
    },

    /**
     * 去掉总平台壳，得到可勾选的学校根列表。最后更新：2026-09-03
     */
    resolveAssignTreeRoots(treeRoot) {
      if (!treeRoot) return [];
      // 必须先剥总平台，避免 value="0" 被误判成学校
      if (this.isAssignPlatformNode(treeRoot)) {
        return Array.isArray(treeRoot.children) ? treeRoot.children.slice() : [];
      }
      if (this.isAssignSchoolNode(treeRoot)) return [treeRoot];
      if (treeRoot.children && treeRoot.children.length) {
        return treeRoot.children;
      }
      const value = Number(treeRoot.value);
      return value > 0 ? [treeRoot] : [];
    },

    /**
     * 递归登记部门节点，便于按 Id 回显。创建于 2026-08-26
     */
    registerAssignDeptNodes(nodes, map) {
      if (!nodes || !nodes.length) return;
      nodes.forEach((node) => {
        if (!node || node.value == null) return;
        const id = normalizeDeptId(node.value);
        if (!id) return;
        // 统一 value 为字符串，避免雪花 Id 被 Number() 截断。最后修改：2026-10-18
        node.value = id;
        map[id] = node;
        if (node.children && node.children.length) {
          this.registerAssignDeptNodes(node.children, map);
        }
      });
    },

    /**
     * 浅拷贝子树。创建于 2026-08-26
     */
    cloneAssignSubTree(nodes) {
      if (!nodes || !nodes.length) return [];
      return nodes.map((node) => {
        const cloned = Object.assign({}, node);
        cloned.disabled = !!node.disabled;
        if (node.children && node.children.length) {
          cloned.children = this.cloneAssignSubTree(node.children);
        } else {
          cloned.children = [];
        }
        return cloned;
      });
    },

    /**
     * 深拷贝部门树，避免改到前端缓存里的同一份对象。创建于 2026-09-03
     */
    cloneAssignTreeData(data) {
      if (data == null) return null;
      try {
        return JSON.parse(JSON.stringify(data));
      } catch (e) {
        return data;
      }
    },

    /**
     * 分配弹窗内清除 disabled，超管需要可选全部学校/部门。创建于 2026-09-03
     */
    clearAssignTreeDisabled(nodes) {
      if (!nodes || !nodes.length) return;
      nodes.forEach((node) => {
        if (!node) return;
        node.disabled = false;
        if (node.children && node.children.length) {
          this.clearAssignTreeDisabled(node.children);
        }
      });
    },

    /**
     * 加载完整组织树并按学校/子部门回显。
     * 不用教学树：部分学校年级 BigType=0，教学树会滤掉下级导致无法展开。最后更新：2026-09-07
     */
    loadAssignDeptTree(initialDids, forceScopeSchoolId) {
      const requestId = (this.assignDeptTreeRequestId += 1);
      this.assignDeptTreeLoading = true;
      const getScopePromise =
        forceScopeSchoolId !== undefined
          ? Promise.resolve(forceScopeSchoolId)
          : this.resolveAssignScopeSchoolId(this.assignDeptUser);

      getScopePromise
        .then((scopeSchoolId) => {
          if (requestId !== this.assignDeptTreeRequestId) return null;
          const actualScopeId = scopeSchoolId > 0 ? scopeSchoolId : 0;
          this.assignDeptScopeSchoolId = actualScopeId;
          const para = {
            pid: 0,
            type: 0,
            bigType: -1,
            scopeDepartmentId: actualScopeId,
          };
          return getDepartmentTree(para, { bypassCache: true }).then((res) => ({
            res,
            scopeSchoolId: actualScopeId,
          }));
        })
        .then((payload) => {
          if (!payload || requestId !== this.assignDeptTreeRequestId) return;
          const scopeSchoolId = payload.scopeSchoolId;
          const res = payload.res;
          const treeRoot = this.cloneAssignTreeData(
            res.data && res.data.response ? res.data.response : null
          );
          let topChildren = this.resolveAssignTreeRoots(treeRoot);
          // scope 后根常为当前学校本身，确保只保留该校
          if (normalizeDeptId(scopeSchoolId)) {
            let matchedNode = null;
            if (treeRoot && deptIdsEqual(treeRoot.value, scopeSchoolId)) {
              matchedNode = treeRoot;
              topChildren = [treeRoot];
            } else {
              const matched = (topChildren || []).find(
                (n) => deptIdsEqual(n.value, scopeSchoolId)
              );
              if (matched) {
                matchedNode = matched;
                topChildren = [matched];
              } else if (treeRoot && Array.isArray(treeRoot.children)) {
                const child = treeRoot.children.find(
                  (n) => deptIdsEqual(n.value, scopeSchoolId)
                );
                if (child) {
                  matchedNode = child;
                  topChildren = [child];
                }
              }
            }
            this.assignDeptScopeSchoolName = matchedNode ? (matchedNode.label || matchedNode.Name || "") : "";
          } else {
            this.assignDeptScopeSchoolName = "";
          }
          this.clearAssignTreeDisabled(topChildren);
          const nodeMap = {};
          this.registerAssignDeptNodes(topChildren, nodeMap);
          this.assignDeptNodeMap = nodeMap;
          this.assignDeptTopNodes = topChildren || [];

          this.assignSchoolList = topChildren
            .filter((n) => this.isAssignSchoolNode(n))
            .map((n) => ({
              value: normalizeDeptId(n.value),
              label: n.label || n.Name,
              fullLabel: n.fullLabel || n.label,
              DeptOrgType: n.DeptOrgType,
              children: n.children || [],
            }))
            .filter((s) => !!s.value);

          const dids = (initialDids || []).map((id) => normalizeDeptId(id)).filter((id) => !!id);
          const schoolIdSet = {};
          this.assignSchoolList.forEach((s) => {
            schoolIdSet[s.value] = true;
          });

          const schoolIds = [];
          const subIds = [];
          // 当前范围外的原绑定先挂起，保存时合并回去，避免误清空其他学校权限
          const preservedOutOfScopeIds = [];
          dids.forEach((id) => {
            const node = nodeMap[id] || nodeMap[String(id)];
            if (schoolIdSet[id] || (node && this.isAssignSchoolNode(node))) {
              schoolIds.push(id);
            } else if (node) {
              subIds.push(id);
            } else if (scopeSchoolId > 0) {
              preservedOutOfScopeIds.push(id);
            } else {
              subIds.push(id);
            }
          });

          this.assignPreservedOutOfScopeIds = preservedOutOfScopeIds;
          this.assignSchoolIds = schoolIds;
          this.assignSubDeptIds = subIds;
          this.syncAssignSchoolNodes();
          this.syncAssignSubDeptNodes();
          this.buildAssignSubDeptTree();
          // 有已选时展开到对应节点（只展开祖先路径，不整树展开）
          const focusSubId = (this.assignSubDeptNodes[0] && this.assignSubDeptNodes[0].value)
            || (subIds.length ? subIds[0] : 0);
          if (focusSubId && this.assignSubDeptTree.length) {
            this.prepareAssignSubDeptExpandPath(focusSubId);
            this.assignDeptTab = "sub";
            this.$nextTick(() => {
              this.$nextTick(() => {
                this.locateAssignSubDept(focusSubId);
              });
            });
          } else if (schoolIds.length) {
            this.assignDeptTab = "school";
            this.$nextTick(() => {
              this.locateAssignSchool(schoolIds[0]);
            });
          } else {
            this.assignDeptTab = "school";
          }
        })
        .catch(() => {
          if (requestId !== this.assignDeptTreeRequestId) return;
          this.assignSchoolList = [];
          this.assignDeptTopNodes = [];
          this.assignSubDeptTree = [];
          this.assignDeptNodeMap = {};
          this.assignPreservedOutOfScopeIds = [];
          this.$message.error("部门树加载失败，请重试");
        })
        .finally(() => {
          if (requestId !== this.assignDeptTreeRequestId) return;
          this.assignDeptTreeLoading = false;
        });
    },

    /**
     * 根据节点向上找到所属学校 Id。创建于 2026-08-26
     */
    findAssignSchoolIdByNode(node) {
      if (!node) return null;
      let current = node;
      const guard = {};
      while (current && current.value && !guard[current.value]) {
        guard[current.value] = true;
        if (this.isAssignSchoolNode(current)) {
          return current.value;
        }
        const parentId = current.Pid;
        if (!parentId || !this.assignDeptNodeMap[parentId]) {
          break;
        }
        current = this.assignDeptNodeMap[parentId];
      }
      return null;
    },

    /**
     * 收集某节点全部祖先 Id（用于展开路径）。创建于 2026-09-03
     */
    collectAssignAncestorKeys(nodeId) {
      const keys = [];
      let current = this.assignDeptNodeMap[Number(nodeId)] || this.assignDeptNodeMap[nodeId];
      const guard = {};
      while (current && current.Pid && !guard[current.Pid]) {
        const parentId = Number(current.Pid);
        if (!parentId) break;
        guard[parentId] = true;
        keys.push(parentId);
        current = this.assignDeptNodeMap[parentId] || this.assignDeptNodeMap[String(parentId)];
      }
      return keys;
    },

    /**
     * 构建跨校子部门总树。默认全部折叠，仅回显勾选。最后更新：2026-09-03
     */
    buildAssignSubDeptTree() {
      const roots = [];
      // 优先学校列表；若识别失败则从顶层再剥一层总平台
      let topNodes = (this.assignSchoolList && this.assignSchoolList.length)
        ? this.assignSchoolList
        : (this.assignDeptTopNodes || []);
      if (topNodes.length === 1 && this.isAssignPlatformNode(topNodes[0])) {
        topNodes = topNodes[0].children || [];
      }

      topNodes.forEach((school) => {
        const rawId = school && school.value;
        const src = this.assignDeptNodeMap[Number(rawId)]
          || this.assignDeptNodeMap[rawId]
          || school;
        const clonedList = this.cloneAssignSubTree([
          Object.assign({}, src, {
            children: (src.children || school.children || []).slice(),
          }),
        ]);
        if (clonedList.length) {
          roots.push(clonedList[0]);
        }
      });
      this.assignSubDeptTree = roots;
      // 不预展开，学校太多；需要时点右侧已选再定位展开
      this.assignSubDeptExpandKeys = [];
    },

    /**
     * 预计算展开到目标节点的祖先路径（挂载树前写入 default-expanded-keys）。创建于 2026-09-03
     */
    prepareAssignSubDeptExpandPath(deptId) {
      const id = Number(deptId);
      if (!id) {
        this.assignSubDeptExpandKeys = [];
        return;
      }
      const expandKeys = {};
      this.collectAssignAncestorKeys(id).forEach((key) => {
        expandKeys[Number(key)] = true;
      });
      const schoolId = this.findAssignSchoolIdByNode(
        this.assignDeptNodeMap[id] || this.assignDeptNodeMap[String(id)]
      );
      if (schoolId) expandKeys[Number(schoolId)] = true;
      this.assignSubDeptExpandKeys = Object.keys(expandKeys).map((key) => Number(key));
    },

    /**
     * 打开后定位到已选节点。创建于 2026-09-03
     */
    focusAssignInitialSelection() {
      if ((this.assignSubDeptNodes || []).length && (this.assignSubDeptTree || []).length) {
        this.locateAssignSubDept(this.assignSubDeptNodes[0].value);
        return;
      }
      if ((this.assignSchoolIds || []).length) {
        this.locateAssignSchool(this.assignSchoolIds[0]);
      }
    },

    /**
     * 定位到学校级列表中的学校。创建于 2026-09-03
     */
    locateAssignSchool(schoolId) {
      const id = Number(schoolId);
      if (!id) return;
      this.assignDeptTab = "school";
      this.assignSchoolFilter = "";
      this.$nextTick(() => {
        const dialog = document.querySelector(".assign-dept-dialog");
        if (!dialog) return;
        const row = dialog.querySelector(`[data-assign-school-id="${id}"]`);
        if (!row) return;
        row.scrollIntoView({ block: "nearest", behavior: "smooth" });
        row.classList.add("ad-locate-flash");
        setTimeout(() => {
          row.classList.remove("ad-locate-flash");
        }, 1400);
      });
    },

    /**
     * 定位到子部门树中的节点：切 Tab、展开祖先、滚入视野。最后更新：2026-09-03
     */
    locateAssignSubDept(deptId) {
      const id = Number(deptId);
      if (!id || !(this.assignSubDeptTree || []).length) return;
      this.assignSubDeptFilter = "";
      this.prepareAssignSubDeptExpandPath(id);
      // 先切 Tab，等 v-if 挂载树后再勾选/滚动
      this.assignDeptTab = "sub";

      this.$nextTick(() => {
        const tree = this.$refs.assignSubDeptTree;
        if (!tree) return;
        this.applyAssignSubDeptCheckedKeys(this.assignSubDeptIds);
        (this.assignSubDeptExpandKeys || []).forEach((key) => {
          const node = tree.getNode(key);
          if (node && !node.expanded) {
            node.expand();
          }
        });
        if (typeof tree.setCurrentKey === "function") {
          tree.setCurrentKey(id);
        }
        this.$nextTick(() => {
          this.scrollAssignTreeNodeIntoView(id);
        });
      });
    },

    /**
     * 将 el-tree 节点滚到可视区域并高亮。创建于 2026-09-03
     */
    scrollAssignTreeNodeIntoView(nodeId) {
      const tree = this.$refs.assignSubDeptTree;
      if (!tree || !tree.$el) return;
      const key = String(nodeId);
      const el =
        tree.$el.querySelector(`.el-tree-node[data-key="${key}"] > .el-tree-node__content`)
        || tree.$el.querySelector(`.el-tree-node[data-key="${key}"]`);
      if (!el) return;
      el.scrollIntoView({ block: "nearest", behavior: "smooth" });
      el.classList.add("ad-locate-flash");
      setTimeout(() => {
        el.classList.remove("ad-locate-flash");
      }, 1400);
    },

    /**
     * 学校 Id 集合（用于从子部门勾选结果中排除学校根）。创建于 2026-08-26
     */
    getAssignSchoolIdSet() {
      const schoolIdSet = {};
      (this.assignSchoolList || []).forEach((s) => {
        schoolIdSet[Number(s.value)] = true;
      });
      return schoolIdSet;
    },

    /**
     * 回显勾选（级联模式下先设叶子/已存节点，再同步）。创建于 2026-08-26
     */
    applyAssignSubDeptCheckedKeys(ids) {
      const tree = this.$refs.assignSubDeptTree;
      if (!tree) return;
      this.assignSubDeptSyncing = true;
      try {
        tree.setCheckedKeys((ids || []).map((id) => Number(id)).filter((id) => id > 0));
      } finally {
        this.$nextTick(() => {
          this.assignSubDeptSyncing = false;
          this.syncAssignSubDeptFromTree();
        });
      }
    },

    /**
     * 判断节点是否落在指定学校下（不含学校自身）。创建于 2026-08-26
     */
    isNodeUnderSchool(nodeId, schoolId) {
      if (!normalizeDeptId(nodeId) || !normalizeDeptId(schoolId) || deptIdsEqual(nodeId, schoolId)) return false;
      let current = this.assignDeptNodeMap[normalizeDeptId(nodeId)] || this.assignDeptNodeMap[nodeId];
      const guard = {};
      while (current && current.value && !guard[current.value]) {
        guard[current.value] = true;
        if (deptIdsEqual(current.value, schoolId)) return true;
        if (deptIdsEqual(current.Pid, schoolId)) return true;
        current = this.assignDeptNodeMap[normalizeDeptId(current.Pid)] || this.assignDeptNodeMap[current.Pid];
      }
      return false;
    },

    /**
     * 部门树节点过滤。创建于 2026-08-26
     */
    filterAssignDeptNode(value, data) {
      if (!value) return true;
      return (data.label || "").indexOf(value) !== -1;
    },

    onAssignSchoolChange(val) {
      const selectable = {};
      (this.assignSchoolList || []).forEach((s) => {
        selectable[Number(s.value)] = true;
      });
      this.assignSchoolIds = (val || [])
        .map((id) => Number(id))
        .filter((id) => id > 0 && selectable[id]);
      this.syncAssignSchoolNodes();
    },

    /**
     * 学校是否已勾选（兼容 number/string）。创建于 2026-08-26
     */
    isAssignSchoolSelected(schoolId) {
      return (this.assignSchoolIds || []).some((id) => deptIdsEqual(id, schoolId));
    },

    /**
     * 点击学校行/复选框统一切换勾选，避免与 checkbox-group 双向绑定冲突。最后更新：2026-08-26
     */
    toggleAssignSchool(schoolId) {
      const id = Number(schoolId);
      if (!id) return;
      // 仅允许勾选未禁用且出现在学校列表中的节点。创建于 2026-08-26
      const selectable = (this.assignSchoolList || []).some((s) => Number(s.value) === id);
      if (!selectable) return;
      if (this.isAssignSchoolSelected(id)) {
        this.assignSchoolIds = (this.assignSchoolIds || [])
          .map((x) => Number(x))
          .filter((x) => x !== id);
      } else {
        this.assignSchoolIds = (this.assignSchoolIds || [])
          .map((x) => Number(x))
          .filter((x) => x > 0)
          .concat(id);
      }
      this.syncAssignSchoolNodes();
    },

    syncAssignSchoolNodes() {
      const idSet = {};
      (this.assignSchoolIds || []).forEach((id) => {
        idSet[Number(id)] = true;
      });
      this.assignSchoolNodes = this.assignSchoolList
        .filter((s) => idSet[Number(s.value)])
        .map((s) => ({ value: Number(s.value), label: s.label, scope: "school" }));
    },

    /**
     * 子部门树勾选变化（含级联）。最后更新：2026-08-26
     */
    onAssignSubDeptCheck() {
      if (this.assignSubDeptSyncing) return;
      this.syncAssignSubDeptFromTree();
    },

    /**
     * 从总树同步已选子部门（排除学校根；学校级权限走另一 Tab）。最后更新：2026-08-26
     */
    syncAssignSubDeptFromTree() {
      const tree = this.$refs.assignSubDeptTree;
      if (!tree) {
        this.syncAssignSubDeptNodes();
        return;
      }
      const schoolIdSet = this.getAssignSchoolIdSet();
      // 保存全部已勾选子部门（含级联下级），确保权限绑定完整
      this.assignSubDeptIds = (tree.getCheckedKeys(false) || [])
        .map((id) => Number(id))
        .filter((id) => id > 0 && !schoolIdSet[id]);
      this.syncAssignSubDeptNodes();
    },

    /**
     * 压缩展示：若上级已全选，右侧只显示上级。创建于 2026-08-26
     */
    compressAssignSubDeptIds(ids) {
      const idSet = {};
      (ids || []).forEach((id) => {
        idSet[Number(id)] = true;
      });
      return (ids || [])
        .map((id) => Number(id))
        .filter((id) => {
          const node = this.assignDeptNodeMap[id];
          if (!node) return true;
          let parent = this.assignDeptNodeMap[node.Pid] || this.assignDeptNodeMap[Number(node.Pid)];
          const guard = {};
          while (parent && parent.value && !guard[parent.value]) {
            guard[parent.value] = true;
            if (idSet[Number(parent.value)]) return false;
            parent = this.assignDeptNodeMap[parent.Pid] || this.assignDeptNodeMap[Number(parent.Pid)];
          }
          return true;
        });
    },

    syncAssignSubDeptNodes() {
      const displayIds = this.compressAssignSubDeptIds(this.assignSubDeptIds);
      const selectedSet = {};
      (this.assignSubDeptIds || []).forEach((id) => {
        selectedSet[Number(id)] = true;
      });
      this.assignSubDeptNodes = displayIds.map((id) => {
        const numId = Number(id);
        const node = this.assignDeptNodeMap[numId] || this.assignDeptNodeMap[String(numId)];
        const childCount = this.countAssignSelectedDescendants(numId, selectedSet);
        const schoolId = this.findAssignSchoolIdByNode(node);
        const school = schoolId
          ? this.assignSchoolList.find((s) => Number(s.value) === Number(schoolId))
          : null;
        return {
          value: numId,
          label: node ? (node.label || node.Name || String(numId)) : String(numId),
          fullLabel: node ? (node.fullLabel || node.label || node.Name) : String(numId),
          childCount: childCount > 0 ? childCount : 0,
          schoolName: school ? school.label : "",
          scope: "sub",
        };
      });
    },

    /**
     * 统计某节点下已勾选的子孙数量（用于已选列表展示）。创建于 2026-08-26
     */
    countAssignSelectedDescendants(nodeId, selectedSet) {
      let count = 0;
      const walk = (id) => {
        const node = this.assignDeptNodeMap[Number(id)] || this.assignDeptNodeMap[id];
        if (!node || !node.children || !node.children.length) return;
        node.children.forEach((child) => {
          const cid = Number(child.value);
          if (!cid) return;
          if (selectedSet[cid]) count += 1;
          walk(cid);
        });
      };
      walk(nodeId);
      return count;
    },

    removeAssignSchool(value) {
      const target = Number(value);
      this.assignSchoolIds = (this.assignSchoolIds || [])
        .map((id) => Number(id))
        .filter((id) => id !== target);
      this.syncAssignSchoolNodes();
    },

    /**
     * 移除汇总中的子部门节点，并级联取消其下级。最后更新：2026-08-26
     */
    removeAssignSubDept(value) {
      const target = Number(value);
      const tree = this.$refs.assignSubDeptTree;
      if (tree) {
        this.assignSubDeptSyncing = true;
        try {
          tree.setChecked(target, false, true);
        } finally {
          this.$nextTick(() => {
            this.assignSubDeptSyncing = false;
            this.syncAssignSubDeptFromTree();
          });
        }
        return;
      }
      const removeSet = {};
      removeSet[target] = true;
      this.collectAssignDescendantIds(target, removeSet);
      this.assignSubDeptIds = (this.assignSubDeptIds || [])
        .map((id) => Number(id))
        .filter((id) => !removeSet[id]);
      this.syncAssignSubDeptNodes();
    },

    /**
     * 收集某节点全部子孙 Id。创建于 2026-08-26
     */
    collectAssignDescendantIds(nodeId, outSet) {
      const node = this.assignDeptNodeMap[Number(nodeId)] || this.assignDeptNodeMap[nodeId];
      if (!node || !node.children || !node.children.length) return;
      node.children.forEach((child) => {
        const cid = Number(child.value);
        if (!cid || outSet[cid]) return;
        outSet[cid] = true;
        this.collectAssignDescendantIds(cid, outSet);
      });
    },

    clearAssignSchools() {
      this.assignSchoolIds = [];
      this.syncAssignSchoolNodes();
    },

    clearAssignSubDepts() {
      this.assignSubDeptIds = [];
      this.syncAssignSubDeptNodes();
      const tree = this.$refs.assignSubDeptTree;
      if (tree) {
        this.assignSubDeptSyncing = true;
        try {
          tree.setCheckedKeys([]);
        } finally {
          this.$nextTick(() => {
            this.assignSubDeptSyncing = false;
          });
        }
      }
    },

    clearAssignDeptSelection() {
      this.clearAssignSchools();
      this.clearAssignSubDepts();
    },

    onAssignDeptClosed() {
      // 关闭后作废进行中的树请求，避免回写空态/旧数据。创建于 2026-09-03
      this.assignDeptTreeRequestId += 1;
      this.assignDeptUser = null;
      this.assignDeptTab = "school";
      this.assignDeptNodeMap = {};
      this.assignDeptTopNodes = [];
      this.assignSchoolList = [];
      this.assignSchoolFilter = "";
      this.assignSchoolIds = [];
      this.assignSchoolNodes = [];
      this.assignSubDeptTree = [];
      this.assignSubDeptExpandKeys = [];
      this.assignSubDeptFilter = "";
      this.assignSubDeptIds = [];
      this.assignSubDeptNodes = [];
      this.assignPreservedOutOfScopeIds = [];
      this.assignSubDeptSyncing = false;
      this.assignDeptTreeLoading = false;
      this.assignDeptScopeSchoolId = 0;
      this.assignDeptScopeSchoolName = "";
    },

    /**
     * 提交部门分配：学校级 + 子部门合并写入 Dids。最后更新：2026-10-29
     */
    submitAssignDept() {
      if (!this.assignDeptUser || !this.assignDeptUser.uID) {
        this.$message.error("用户信息丢失，请重新打开");
        return;
      }
      if (this.assignDeptTreeLoading) {
        this.$message.warning("部门树加载中，请稍后再保存");
        return;
      }
      // 提交前再同步一次当前学校树勾选，避免未触发 check-change 的边界情况
      if (this.assignDeptTab === "sub") {
        this.syncAssignSubDeptFromTree();
      }

      const schoolIds = (this.assignSchoolIds || []).slice();
      const subIds = (this.assignSubDeptIds || []).slice();
      const preservedIds = (this.assignPreservedOutOfScopeIds || []).slice();
      const merged = [];
      const seen = {};
      // 范围外原绑定一并保留，避免在单校视图下保存时误清其他学校权限
      schoolIds.concat(subIds).concat(preservedIds).forEach((id) => {
        if (!id || seen[id]) return;
        seen[id] = true;
        merged.push(id);
      });

      const para = Object.assign({}, this.assignDeptUser);
      // 分配部门只更新部门绑定，不回写密码字段
      delete para.uLoginPWD;
      delete para.LoginPWD;
      para.Dids = merged;
      // 主部门优先取学校级，便于列表展示整校归属
      para.DepartmentId = schoolIds.length
        ? schoolIds[0]
        : (subIds.length ? subIds[0] : (preservedIds.length ? preservedIds[0] : 0));
      para.birth =
        !para.birth || para.birth == ""
          ? util.formatDate.format(new Date(), "yyyy-MM-dd")
          : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");
      if (!Array.isArray(para.RIDs)) {
        para.RIDs = para.RIDs ? [para.RIDs] : [];
      }

      const overlap = this.assignDeptOverlapInfo;
      if (overlap.hasOverlap) {
        this.$confirm(
          `已分配学校级权限（${overlap.schoolText}）登录后可管理整校，同校 ${overlap.overlapCount} 项子部门不会额外生效。是否仍要保存？`,
          "权限重叠提示",
          {
            confirmButtonText: "仍要保存",
            cancelButtonText: "返回修改",
            type: "warning",
          }
        )
          .then(() => {
            this.doSubmitAssignDept(para);
          })
          .catch(() => {});
        return;
      }

      this.doSubmitAssignDept(para);
    },

    /**
     * 执行部门分配保存。创建于 2026-08-26
     */
    doSubmitAssignDept(para) {
      this.assignDeptLoading = true;
      editUser(para)
        .then((res) => {
          if (util.isEmt.format(res)) {
            return;
          }
          if (res.data.success) {
            this.$message({
              message: "部门分配成功",
              type: "success",
            });
            this.assignDeptVisible = false;
            this.handleQuery();
          } else {
            this.$message({
              message: res.data.msg || "部门分配失败",
              type: "error",
            });
          }
        })
        .finally(() => {
          this.assignDeptLoading = false;
        });
    },

    // 显示密码安全管理对话框
    openResetPasswordDialog(row) {
      this.isAuthorized = false; // 每次打开弹窗都需要重新验证
      this.rawLoginPWD = row.uLoginPWD || row.LoginPWD || ""; // 提取密文值
      this.decodedPlainPassword = ""; // 清空明文值
      this.resetPwdForm = {
        userId: row.uID,
        uLoginName: row.uLoginName,
        uRealName: row.uRealName,
        authCode: "",
        newPassword: ""
      };
      this.resetPwdVisible = true;
      this.$nextTick(() => {
        this.$refs.authForm && this.$refs.authForm.clearValidate();
        this.$refs.resetPwdForm && this.$refs.resetPwdForm.clearValidate();
      });
    },

    // 验证专属操作授权密码
    handleAuthValidate() {
      this.$refs.authForm.validate((valid) => {
        if (valid) {
          if (this.resetPwdForm.authCode === "yiqiba20260528") {
            this.decodedPlainPassword = "";
            let para = {
              authCode: this.resetPwdForm.authCode,
              passwordMd5: this.rawLoginPWD
            };

            // 如果MD5为空，直接授权通过
            if (!this.rawLoginPWD) {
              this.isAuthorized = true;
              this.$message({
                message: "操作授权成功！",
                type: "success"
              });
              this.resetPwdForm.newPassword = "";
              return;
            }

            this.authLoading = true; // 开启验证加载状态动画
            decodeUserPassword(para).then((res) => {
              this.authLoading = false;
              this.isAuthorized = true;
              if (res.data.success && res.data.response) {
                this.decodedPlainPassword = res.data.response;
                this.$message({
                  message: "身份授权成功！已成功转译出明文密码。",
                  type: "success"
                });
              } else {
                this.$message({
                  message: "操作授权成功！密码强度极高，未在弱密码库中匹配成功。",
                  type: "warning"
                });
              }
              this.resetPwdForm.newPassword = "";
            }).catch(() => {
              this.authLoading = false;
              this.isAuthorized = true;
              this.resetPwdForm.newPassword = "";
            });
          } else {
            this.$message.error("操作授权密码错误，无权管理密码数据！");
          }
        }
      });
    },

    // 确认并提交重置密码请求
    submitResetPassword() {
      this.$refs.resetPwdForm.validate((valid) => {
        if (valid) {
          if (this.resetPwdForm.authCode !== "yiqiba20260528") {
            this.$message.error("授权验证校验异常，请重新尝试授权操作！");
            return;
          }
          this.$confirm("确认将该用户的密码重置为新输入的密码，并执行 32 位 MD5 加密存盘吗？", "提示", {
            type: "warning"
          }).then(() => {
            this.resetPwdLoading = true;
            let para = {
              userId: this.resetPwdForm.userId,
              authCode: this.resetPwdForm.authCode,
              newPassword: this.resetPwdForm.newPassword
            };
            resetUserPassword(para).then((res) => {
              this.resetPwdLoading = false;
              if (res.data.success) {
                this.$message.success("密码已成功重置并散列加密存盘！");
                this.resetPwdVisible = false;
                this.handleQuery();
              } else {
                this.$message.error(res.data.msg || "密码重置操作失败");
              }
            }).catch(() => {
              this.resetPwdLoading = false;
              this.$message.error("请求发生异常，请稍后重试");
            });
          });
        }
      });
    }
  },
  watch: {
    assignSubDeptFilter(val) {
      if (this.$refs.assignSubDeptTree) {
        this.$refs.assignSubDeptTree.filter(val);
      }
    },
    assignDeptTab(val) {
      if (val === "sub" && this.assignSubDeptTree.length) {
        this.$nextTick(() => {
          this.applyAssignSubDeptCheckedKeys(this.assignSubDeptIds);
        });
      }
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

/* 表格内容水平垂直居中；长名称列允许换行且不被裁切。最后修改：2026-08-27 */
.custom-tbl /deep/ .el-table__body td.el-table__cell {
  vertical-align: middle;
  height: auto;
  overflow: visible;
}
.custom-tbl /deep/ .el-table__body td.el-table__cell > .cell {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: normal;
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
  word-break: break-word;
  height: auto;
}
.custom-tbl /deep/ td.is-wrap-cell {
  text-align: center;
}
.custom-tbl /deep/ td.is-wrap-cell .el-tag,
.custom-tbl /deep/ td.is-wrap-cell .name-cell__tag {
  display: inline-block;
  max-width: 100%;
  height: auto !important;
  line-height: 1.4 !important;
  white-space: normal !important;
  word-break: break-all;
  overflow: visible !important;
  text-overflow: clip;
  box-sizing: border-box;
}

.op-btn-assign {
  color: var(--btn-primary, #2563eb);
  font-weight: 600;
  cursor: pointer;
}

.op-btn-pwd {
  color: #e6a23c;
  font-weight: 600;
  cursor: pointer;
}

.add-dept-hint {
  margin: 0 0 16px;
}

/* 分配部门弹窗：左右分栏 + 轻量卡片。最后更新：2026-08-29 */
.ad-shell {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ad-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid #e8edf3;
  border-radius: 10px;
  background: linear-gradient(180deg, #f8fafc 0%, #fff 100%);
}

.ad-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.ad-avatar {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: var(--btn-primary, #2563eb);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 18px;
  box-shadow: 0 4px 10px rgba(37, 99, 235, 0.18);
}

.ad-user {
  min-width: 0;
}

.ad-name {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.35;
  display: flex;
  align-items: center;
  gap: 8px;
}

.ad-scope-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 500;
  padding: 1px 7px;
  border-radius: 4px;
  color: #0284c7;
  background: #f0f9ff;
  border: 1px solid #bae6fd;
}

.ad-scope-badge--all {
  color: #059669;
  background: #ecfdf5;
  border-color: #a7f3d0;
}

.ad-sub {
  margin-top: 3px;
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
}

.ad-scope-switch-btn {
  margin-left: 8px;
  padding: 0;
  font-size: 12px;
  color: var(--btn-primary, #2563eb);
}

.ad-scope-switch-btn:hover {
  text-decoration: underline;
}

.ad-stats {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.ad-stat-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  color: #475569;
  background: #fff;
  border: 1px solid #e2e8f0;
}

.ad-stat-pill b {
  color: var(--btn-primary, #2563eb);
  font-size: 14px;
  font-weight: 700;
}

.ad-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 520px;
  min-height: 520px;
  max-height: 520px;
}

.ad-main {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(0, 0.95fr);
  gap: 14px;
  flex: 1;
  min-height: 0;
  height: auto;
}

.ad-picker,
.ad-summary {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  min-height: 0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.ad-summary {
  background: #f8fafc;
}

.ad-seg {
  display: flex;
  gap: 0;
  padding: 0 12px;
  border-bottom: 1px solid #e8edf3;
  background: #fafbfc;
  flex-shrink: 0;
}

.ad-seg-item {
  position: relative;
  height: 42px;
  padding: 0 14px;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: #64748b;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: color 0.18s ease;
}

.ad-seg-item::after {
  content: '';
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 0;
  height: 2px;
  border-radius: 2px 2px 0 0;
  background: transparent;
  transition: background-color 0.18s ease;
}

.ad-seg-item:hover {
  color: var(--btn-primary, #2563eb);
}

.ad-seg-item.active {
  color: var(--btn-primary, #2563eb);
  font-weight: 600;
  background: transparent;
}

.ad-seg-item.active::after {
  background: var(--btn-primary, #2563eb);
}

.ad-pane {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.ad-pane > .el-input {
  flex-shrink: 0;
}

.ad-hint-line {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin: 0;
  flex-shrink: 0;
  font-size: 12px;
  line-height: 1.45;
  color: #64748b;
}

.ad-hint-line i {
  margin-top: 2px;
  font-size: 13px;
  color: #94a3b8;
  flex-shrink: 0;
}

.ad-scroll {
  flex: 1;
  min-height: 0;
  height: 0;
  overflow: hidden;
  padding: 0;
  border: 1px solid #e8edf3;
  border-radius: 10px;
  background: #fcfdfe;
  display: flex;
  flex-direction: column;
}

.ad-scroll-pane {
  flex: 1;
  min-height: 0;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 8px;
}

.ad-school-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.ad-school-row {
  display: block;
  padding: 9px 10px;
  border: 1px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.ad-school-row:hover {
  background: #f8fafc;
  border-color: #e2e8f0;
}

.ad-school-row.active {
  background: #eff6ff;
  border-color: #bfdbfe;
}

.ad-school-row /deep/ .el-checkbox {
  display: flex;
  align-items: center;
  width: 100%;
  margin-right: 0;
}

.ad-school-row /deep/ .el-checkbox__label {
  white-space: normal;
  line-height: 1.45;
  color: #334155;
  font-size: 13px;
}

.ad-scroll--tree /deep/ .ad-dept-tree {
  background: transparent;
}

.ad-scroll--tree /deep/ .el-tree-node__content {
  height: 34px;
  border-radius: 6px;
  transition: background-color 0.15s ease;
}

.ad-scroll--tree /deep/ .el-tree-node__content:hover {
  background: #f1f5f9;
}

.ad-scroll--tree /deep/ .el-tree-node__label {
  font-size: 13px;
  color: #334155;
}

.ad-scroll--tree /deep/ .el-tree-node__expand-icon {
  color: #94a3b8;
}

/* 叶子节点不要显示可点的展开箭头（避免空校看起来点不了）。最后更新：2026-09-03 */
.ad-scroll--tree /deep/ .el-tree-node__expand-icon.is-leaf {
  color: transparent;
  cursor: default;
}

.ad-summary-top {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  border-bottom: 1px solid #e8edf3;
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  background: #fff;
  flex-shrink: 0;
}

.ad-summary-body {
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

.ad-summary-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  color: var(--btn-primary, #2563eb);
  background: #eff6ff;
}

.ad-summary-top .ad-link {
  margin-left: auto;
}

.ad-overlap-tip {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  font-size: 12px;
  line-height: 1.45;
  color: #92400e;
  flex-shrink: 0;
}

.ad-overlap-tip i {
  margin-top: 1px;
  flex-shrink: 0;
  font-size: 14px;
  color: #d97706;
}

.ad-overlap-tip b {
  font-weight: 600;
  color: #b45309;
}

.ad-link {
  border: 0;
  background: transparent;
  color: var(--btn-primary, #2563eb);
  font-size: 12px;
  cursor: pointer;
  padding: 0;
}

.ad-link:disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}

.ad-summary-group {
  padding: 12px 14px;
  border-bottom: 1px solid #e8edf3;
}

.ad-summary-group:last-child {
  border-bottom: 0;
}

.ad-pick-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: visible;
  padding-right: 2px;
}

.ad-summary-label {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  text-transform: none;
}

.ad-summary-label em {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  font-style: normal;
  font-size: 11px;
  font-weight: 700;
  color: var(--btn-primary, #2563eb);
  background: #eff6ff;
}

.ad-summary-label .ad-link {
  margin-left: auto;
}

.ad-pick-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #e2e8f0;
  cursor: default;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.ad-pick-item:hover {
  border-color: #cbd5e1;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

.ad-pick-item.is-locatable {
  cursor: pointer;
}

.ad-pick-item.is-locatable:hover {
  border-color: #93c5fd;
  background: #f8fbff;
}

.ad-school-row.ad-locate-flash,
.ad-dept-tree /deep/ .el-tree-node__content.ad-locate-flash {
  animation: ad-locate-flash 1.2s ease;
}

@keyframes ad-locate-flash {
  0%,
  100% {
    background-color: transparent;
  }
  30%,
  70% {
    background-color: #dbeafe;
  }
}

.ad-pick-item.school {
  border-color: #bfdbfe;
  background: #f8fbff;
}

.ad-pick-item > i {
  color: #909399;
  font-size: 14px;
  flex-shrink: 0;
}

.ad-pick-item.school > i {
  color: var(--btn-primary, #2563eb);
}

.ad-pick-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ad-pick-text {
  font-size: 12px;
  color: #303133;
  line-height: 1.35;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ad-pick-extra {
  font-size: 11px;
  color: #909399;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ad-pick-remove {
  width: 22px;
  height: 22px;
  margin-left: auto;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;
  transition: color 0.15s ease, background-color 0.15s ease;
}

.ad-pick-remove:hover {
  color: #ef4444;
  background: #fef2f2;
}

.ad-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-content: flex-start;
  max-height: 150px;
  overflow: auto;
}

.ad-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  padding: 24px 12px;
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
  line-height: 1.5;
  box-sizing: border-box;
}

.ad-empty.sm {
  min-height: 56px;
  height: 56px;
  padding: 0 8px;
  text-align: center;
  font-size: 12px;
  color: #94a3b8;
  border: 1px dashed #e2e8f0;
  border-radius: 8px;
  background: #fff;
}

/* 高级授权与密码管理样式 */
.pwd-dialog-content {
  padding: 10px 5px;
}
.auth-panel {
  text-align: center;
  padding: 20px 10px;
}
.auth-panel .el-button {
  min-width: 100px;
  white-space: nowrap;
}
.auth-icon {
  font-size: 54px;
  color: #e6a23c;
  margin-bottom: 18px;
  animation: pulse 2s infinite;
}
.auth-tips {
  font-size: 14px;
  color: #606266;
  margin-bottom: 25px;
  line-height: 1.5;
}
.pwd-analysis-card {
  background: linear-gradient(135deg, rgba(230, 162, 60, 0.05) 0%, rgba(245, 108, 108, 0.05) 100%);
  border: 1px dashed rgba(230, 162, 60, 0.35);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
}
.pwd-analysis-title {
  font-size: 14px;
  font-weight: 600;
  color: #e6a23c;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.pwd-analysis-title i {
  margin-right: 6px;
  font-size: 16px;
}
.pwd-hash-value {
  font-family: Consolas, Monaco, monospace;
  background-color: #f4f4f5;
  padding: 8px 12px;
  border-radius: 4px;
  color: #909399;
  font-size: 13px;
  word-break: break-all;
  border: 1px solid #e4e7ed;
  margin: 5px 0 12px 0;
  text-shadow: 0 1px 0 #fff;
  letter-spacing: 0.5px;
}
.pwd-analysis-desc {
  font-size: 12px;
  color: #909399;
  line-height: 1.6;
}
.name-cell {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 0;
  width: 100%;
}

.name-cell__tag.el-tag {
  max-width: 100%;
  height: auto;
  line-height: 18px;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  word-break: break-all;
}

.name-more-btn {
  padding: 0;
  font-weight: 600;
  flex-shrink: 0;
}

.school-list-pop {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-content: flex-start;
  align-items: flex-start;
  min-height: 168px;
  max-height: 420px;
  overflow-y: auto;
  padding: 4px 2px;
  box-sizing: border-box;
}

.school-list-pop__tag {
  margin: 0;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.85;
  }
  50% {
    transform: scale(1.06);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.85;
  }
}
</style>

<style>
.assign-dept-dialog .el-dialog__body {
  padding: 14px 20px 6px;
  background: #fff;
}

.assign-dept-dialog .el-dialog__header {
  padding: 16px 20px 10px;
  border-bottom: 1px solid #eef0f3;
}

.assign-dept-dialog .el-dialog__footer {
  padding: 10px 20px 16px;
  border-top: 1px solid #eef0f3;
}

.school-list-dialog .el-dialog__body {
  padding: 16px 20px 20px;
  min-height: 200px;
  box-sizing: border-box;
}

@media (max-width: 900px) {
  .assign-dept-dialog {
    width: 96% !important;
  }
  .assign-dept-dialog .ad-content {
    height: auto;
    min-height: 520px;
    max-height: none;
  }
  .assign-dept-dialog .ad-main {
    grid-template-columns: 1fr;
  }
  .assign-dept-dialog .ad-picker,
  .assign-dept-dialog .ad-summary {
    height: 520px;
    min-height: 520px;
    max-height: 520px;
  }
}

.mobile-phone-tip {
  margin-top: 4px;
  font-size: 12px;
  line-height: 1.4;
  color: #909399;
}
</style>
